<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  created() {
    if (this.$route.query.token) {
      window.localStorage.token = this.$route.query.token
    }
  }
}
</script>

<style lang="scss">
@import 'tailwindcss/base';
@import 'tailwindcss/components';
@import 'tailwindcss/utilities';

#app {
  @apply min-h-screen bg-white text-gray-700;
}

select {
  background: url('./assets/img/form-select.svg');
  background-size: 12px auto;
  @apply bg-no-repeat;
  background-position: right 10px center;
}

.app-grid {
  @apply flex flex-wrap -mx-2;
  > * {
    @apply px-2;
  }
}

.vdp-datepicker {
  .vdp-datepicker__calendar {
    width: 100% !important;
    @apply rounded border overflow-hidden bg-gray-100 #{!important};

    .cell {
      &:hover {
        @apply bg-gray-300 border-gray-400 #{!important};
      }
    }

    .cell.selected {
      @apply bg-gray-800 text-white;
      &:hover {
        @apply bg-gray-700 #{!important};
      }
    }
  }
}

.form {
  .form-group {
  }

  .form-table {
    @apply w-full border-collapse text-sm;

    tr {
      @apply border-b;
    }
    tr:first-child {
      @apply border-t;
    }
    th {
      @apply font-medium text-gray-600 px-1 text-left;
    }
    th,
    td {
      @apply border-r;

      &:last-child {
        @apply border-r-0;
      }
    }

    input,
    select {
      @apply py-1 px-2 bg-gray-100 outline-none appearance-none rounded-none border-0;
    }

    .form-table-fixed-cell {
      width: 100px;
      > * {
        @apply block w-full;
      }
    }
  }

  .form-selection {
    @apply flex;

    input {
      @apply mr-2 mt-1;
    }
    .form-label {
      @apply mb-0;
    }
  }

  .form-label {
    @apply block text-sm font-medium mb-1 leading-5 text-gray-700;
  }

  .form-field {
    @apply border rounded flex;

    > span {
      @apply block px-3 py-2 bg-gray-100 border-r text-gray-700;
    }

    > input,
    select,
    textarea,
    .StripeElement {
      @apply appearance-none bg-transparent outline-none block flex-grow px-3 py-2 border-r;
    }
    > .StripeElement {
      @apply py-3;
    }
    > :last-child {
      @apply border-r-0;
    }

    &.form-field-empty {
      > input,
      select,
      textarea {
        @apply text-gray-500;
      }
    }

    &.form-field-xl {
      > input,
      select,
      textarea {
        @apply text-xl;
      }
    }
  }

  &.form-light {
    .form-field {
      @apply bg-gray-100;
    }
  }

  &.form-inverted {
    .form-label {
      @apply text-gray-300;
    }

    .form-field {
      @apply bg-white;
    }
  }
}

.steps {
  @apply rounded flex bg-gray-100 font-medium text-sm text-gray-600;

  > div {
    @apply flex-1 py-3 border border-r-0 text-center;
  }

  > div:first-child {
    @apply rounded-tl rounded-bl;
  }

  > div:last-child {
    @apply rounded-tr rounded-br border-r;
  }
}

.progress {
  @apply rounded h-2 mt-2 bg-gray-100 relative overflow-hidden;

  > div {
    @apply bg-gray-500 h-2;
    transition: width 1s;
  }
}

.img-grayscale {
  filter: gray; /* IE6-9 */
  -webkit-filter: grayscale(1); /* Google Chrome, Safari 6+ & Opera 15+ */
  filter: grayscale(1);
}

.img-invert {
  filter: grayscale(1);
  filter: invert(1);
}

.view {
  @apply w-full;

  tr {
    @apply border-b;
  }

  th,
  td {
    @apply py-2 px-3;
  }

  th {
    @apply w-1/4 text-right font-medium text-gray-600;
  }
}

.btn {
  @apply border rounded px-3 py-2 font-medium inline-block outline-none;

  &.btn-sm {
    @apply px-2 py-1 text-sm;
  }
  &.btn-block {
    @apply block w-full;
  }

  &:focus {
    @apply outline-none;
  }
}

.loading {
  position: relative;
  overflow: hidden;
  &::after {
    content: '';
    display: block;
    background-color: #dddfe2;
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    transform: translateX(0);
    animation: 1.5s loading-placeholder ease-in-out infinite;
  }
}

@keyframes loading-placeholder {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}
</style>
